// import Logo from "../assets/Aspetto_Login.png";
import AuthSideImg from "./AuthSideImg";
import { IconMail } from "@tabler/icons-react";
import usePostRequest from "../../hooks/usePostRequest";
import { useState } from "react";
import { API_ENDPOINTS, aspetto_logo } from "../../constant/_constant";
import { useNavigate } from "react-router-dom";

const ResendVerificationEmail = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const { data, isLoading, error, postData } = usePostRequest(
    API_ENDPOINTS.RESEND_EMAIL
  );

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const onSuccess = (response) => {
    setEmail("");
    navigate("/");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    postData({ email }, onSuccess);
  };

  return (
    <div className="row g-0 flex-fill">
      <div className="col-12 col-lg-6 col-xl-4 border-top-wide border-warning d-flex flex-column justify-content-center">
        <div className="container container-tight my-5 px-lg-5">
          <div className="text-center w-50 mb-3 m-auto">
            <img src={aspetto_logo} height={36} alt="aspetto_logo" />
          </div>
          <h2 className="h3 text-center mb-3">Resend Verification Email</h2>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Your Email Address</label>
              <input
                id="email"
                type="email"
                className="form-control"
                name="email"
                required
                placeholder="Enter your email"
                value={email}
                onChange={handleChange}
              />
            </div>
            <div className="form-footer">
              <button
                type="submit"
                className={`btn btn-warning w-100 ${
                  isLoading ? "btn-loading" : ""
                }`}
                disabled={isLoading}
              >
                <IconMail size={20} className="icon" />
                Resend
              </button>
            </div>
          </form>
        </div>
      </div>
      <AuthSideImg />
    </div>
  );
};

export default ResendVerificationEmail;
